import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { ConnectingScreen } from "./ConnectingScreen.js";
/**
 * @internal
 */
function ExternalWalletConnectUI(props) {
    const { onBack, done, wallet, walletInfo, onGetStarted, locale } = props;
    const [errorConnecting, setErrorConnecting] = useState(false);
    const connect = useCallback(() => {
        setErrorConnecting(false);
        wallet
            .connect({
            client: props.client,
            chain: props.chain,
        })
            .then(() => {
            done();
        })
            .catch((e) => {
            console.error(e);
            setErrorConnecting(true);
        });
    }, [props.client, wallet, props.chain, done]);
    const scanStarted = useRef(false);
    useEffect(() => {
        if (scanStarted.current) {
            return;
        }
        scanStarted.current = true;
        connect();
    }, [connect]);
    return (_jsx(ConnectingScreen, { locale: {
            getStartedLink: locale.getStartedLink,
            instruction: locale.connectionScreen.instruction,
            tryAgain: locale.connectionScreen.retry,
            inProgress: locale.connectionScreen.inProgress,
            failed: locale.connectionScreen.failed,
        }, onBack: onBack, walletName: walletInfo.name, walletId: wallet.id, errorConnecting: errorConnecting, onRetry: connect, onGetStarted: onGetStarted, client: props.client, size: props.size }));
}
export default ExternalWalletConnectUI;
//# sourceMappingURL=CoinbaseSDKConnection.js.map